define("ember-svg-jar/inlined/ml", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<g clip-path=\"url(#a)\"><path d=\"M6 22V7H4v17h17v-2H6z\"/><path d=\"M24 21H7V4h14l3 3v14zm-1.995-5.017L14 11l-5 4.983V19h13.005v-3.017zM19 7.25a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5z\"/></g><defs><clipPath id=\"a\"><path d=\"M0 0h28v28H0z\"/></clipPath></defs>",
    "attrs": {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "28",
      "fill": "currentColor",
      "viewBox": "0 0 28 28"
    }
  };
});